import api from "../../../../services/api";

export const getLeadsQueue = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  sourceType: string,
  sourceFilter: any,
  dateRange: any,
  page: number,
  limit: number,
  formId: number | null,
  search: string = "",
) => {
  const response = await api.post("leadService/getQueuesData", {
    signature,
    company_id: parseInt(companyId),
    company_type: companyType,
    source_type: sourceType,
    source_level_1: sourceFilter?.level_1,
    source_level_2: sourceFilter?.level_2,
    source_level_3: sourceFilter?.level_3,
    start_date: dateRange?.start_date,
    end_date: dateRange?.end_date,
    form_id: formId,
    page,
    limit,
    search_term: search,
  });

  const data = response.data.message[0].data;
  return {
    leads: data.leads,
    pagination: data.pagination,
    employees: data.employees || [],
    hierarchy: data.hierarchy,
    counts: data.counts,
  };
};

export const getLeadsHistory = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  sourceType: string,
  sourceFilter: any,
  dateRange: any,
  page: number,
  limit: number,
  formId: number | null,
  search: string = "",
  assignedTo?: string | null,
) => {
  const response = await api.post("leadService/getHistoryData", {
    signature,
    company_id: parseInt(companyId),
    company_type: companyType,
    source_type: sourceType,
    source_level_1: sourceFilter?.level_1,
    source_level_2: sourceFilter?.level_2,
    source_level_3: sourceFilter?.level_3,
    start_date: dateRange?.start_date,
    end_date: dateRange?.end_date,
    page,
    limit,
    form_id: formId,
    search_term: search,
    assigned_to: assignedTo,
  });

  const data = response.data.message[0].data;
  return {
    leads: data.leads,
    pagination: data.pagination,
    employees: data.employees || [],
    hierarchy: data.hierarchy,
    counts: data.counts,
  };
};

export const getLeadsForms = async (
  signature: string | null,
  companyId: string,
  companyType: string,
) => {
  const response = await api.post("leadService/getLeadFormsByCompany", {
    signature,
    company_id: parseInt(companyId),
    company_type: companyType,
  });
  return response?.data?.data?.data || [];
};

export const exportQueueData = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  sourceType: string,
  sourceFilter: any,
  dateRange: any,
  formId: number | null,
  search: string = "",
) => {
  const response = await api.post(
    "leadService/exportQueuesData",
    {
      signature,
      company_id: parseInt(companyId),
      company_type: companyType,
      source_type: sourceType,
      source_level_1: sourceFilter?.level_1,
      source_level_2: sourceFilter?.level_2,
      source_level_3: sourceFilter?.level_3,
      start_date: dateRange?.start_date,
      end_date: dateRange?.end_date,
      form_id: formId,
      search_term: search,
    },
    { responseType: "blob" },
  );
  return response?.data || [];
};

export const exportHistoryData = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  sourceType: string,
  sourceFilter: any,
  dateRange: any,
  formId: number | null,
  search: string = "",
  assignedTo?: string | null,
) => {
  const response = await api.post(
    "leadService/exportHistoryData",
    {
      signature,
      company_id: parseInt(companyId),
      company_type: companyType,
      source_type: sourceType,
      source_level_1: sourceFilter?.level_1,
      source_level_2: sourceFilter?.level_2,
      source_level_3: sourceFilter?.level_3,
      start_date: dateRange?.start_date,
      end_date: dateRange?.end_date,
      form_id: formId,
      search_term: search,
      assigned_to: assignedTo,
    },
    { responseType: "blob" },
  );
  return response?.data || [];
};

export const bulkAssignLeads = async (
  signature: string | null,
  leadIds: React.Key[],
  userId: string,
  companyId: string,
  companyType: string,
) => {
  const response = await api.post("leadService/bulkAssignLeads", {
    signature,
    lead_ids: leadIds,
    user_id: userId,
    company_id: parseInt(companyId),
    company_type: companyType,
  });

};

export const getLeadBankLeads = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  facebookFormId: string | null,
  page: number,
  limit: number,
  leadSourceChild: string | null = null,
  search: string = "",
) => {
  const response = await api.post("leadService/getLeadBankLeads", {
    signature,
    company_id: parseInt(companyId),
    company_type: companyType,
    facebook_form_id: facebookFormId,
    lead_source_child: leadSourceChild,
    search_term: search,
    page,
    limit,
  });

  const data = response.data.message[0].data;
  return {
    leads: data.leads,
    pagination: data.pagination,
  };
};

export const getLeadBankForms = async (
  signature: string | null,
  companyId: string,
  companyType: string,
) => {
  const response = await api.post("leadService/getLeadBankForms", {
    signature,
    company_id: parseInt(companyId),
    company_type: companyType,
  });
  return response.data.message[0].data.forms || [];
};

export const exportLeadBankLeads = async (
  signature: string | null,
  companyId: string,
  companyType: string,
  facebookFormId: string | null,
  leadSourceChild: string | null = null,
  search: string = "",
) => {
  const response = await api.post(
    "leadService/exportLeadBankLeads",
    {
      signature,
      company_id: parseInt(companyId),
      company_type: companyType,
      facebook_form_id: facebookFormId,
      lead_source_child: leadSourceChild,
      search_term: search,
    },
    { responseType: "blob" },
  );
  return response?.data || [];
};

export const assignLeadBankLeads = async (
  signature: string | null,
  leadIds: React.Key[],
  userId: string | null,
  crmFormId: number,
  companyId: string,
  companyType: string,
  assignedLeadType?: string,
) => {
  const response = await api.post("leadService/assignLeadBankLeads", {
    signature,
    lead_ids: leadIds,
    user_id: userId,
    crm_form_id: crmFormId,
    company_id: parseInt(companyId),
    company_type: companyType,
    assigned_lead_type: assignedLeadType,
  });

  return response.data.message[0];
};
